/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

var ko = require("knockout");

var stringUtil = require("../util/string");


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// BoolAdvancedSearchItem template
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~


//-------------------------------------------
// Represents error value the operator observable is set to
// when load method phrase argument can not be parsed to boolean.
var operatorErrorValue = "";


//-------------------------------------------
function BoolAdvancedSearchItem() {
    if (!(this instanceof BoolAdvancedSearchItem)) { return new BoolAdvancedSearchItem(); } // if new was not used, force it now

    // extras
    this.extras = function boolAdvancedSearchItemExtras() { return; };
    this.extras.isError = ko.pureComputed(this._computeIsError, this);

    // indicates how the bool fields are searched
    // - `is true` include any items with `true` value
    // - `is false` excludes any items with `falsy` values
    this.operator = ko.observable(BoolAdvancedSearchItem.defaultValue);
}


//-------------------------------------------
// Gets the id used by the browser to uniquely
// identify the dom element.
BoolAdvancedSearchItem.prototype.templateId = "boolAdvancedSearchItem";


//-------------------------------------------
// Default value for BoolAdvancedSearchItem property select.
BoolAdvancedSearchItem.prototype.defaultValue = "true";


//-------------------------------------------
// Loads the value of this view-model from the
// advancedSearch item.
BoolAdvancedSearchItem.prototype.load = function boolAdvancedSearchItemLoad(phrase) {

    if (typeof phrase !== "string") {
        throw new Error("phrase argument must be of string type.");
    }

    // parse phrase
    var result = stringUtil.parseBoolean(phrase);

    // set known or error (empty) operator
    this.operator(result !== null ? result.toString() : operatorErrorValue);
};


//-------------------------------------------
// Saves the value of this view-model to the
// advancedSearch item. Expects `this` to be the advancedSearch item.
BoolAdvancedSearchItem.prototype.save = function boolAdvancedSearchItemSave() {
    return [this.operator(), false];
};


//-------------------------------------------
BoolAdvancedSearchItem.prototype._computeIsError = function boolAdvancedSearchItemIsError() {
    return this.operator() === operatorErrorValue;
};

module.exports = BoolAdvancedSearchItem;




//////////////////
// WEBPACK FOOTER
// ./~/pli/advancedsearch/boolAdvancedSearchItem.js
// module id = 12
// module chunks = 49